import { Inject, Injectable } from "@angular/core";
import type { CVApiService } from "../services/cv-api.service";
import { ApiResponse } from "src/AngularJS/Models/api-response.model";

export class ProfilePictureApprovalService {
  public dataObj: ProfilePictureApprovalSharedData = {
    loginId: 0,
    imageId: 0,
    loginName: ""
  };

  constructor(private CVApiService: CVApiService) { }

  /**
   * Approves the profile picture
   * */
  public async approveProfilePicture() {
    try {
      let response = await this.CVApiService.put(`/api/v1/profilePictureApprove/${this.dataObj.loginId}`) as ApiResponse<boolean>;
      if (response.status_code >= 200 && response.status_code < 300)
        return response.data;
      else throw response;
    }
    catch (err) {
      console.error(`Failed to approve profile picture.`);
      throw err;
    }
  }

  /**
   * Denies the profile picture
   * */
  public async denyProfilePicture() {
    try {
      let response = await this.CVApiService.put(`/api/v1/profilePictureDeny/${this.dataObj.loginId}`) as ApiResponse<boolean>;
      if (response.status_code >= 200 && response.status_code < 300)
        return response.data;
      else throw response;
    }
    catch (err) {
      console.error(`Failed to deny profile picture.`);
      throw err;
    }
  }

  /**
   * Gets the user profile for the specified user.
   * */
  public async getUserProfile() {
    try {
      let response = await this.CVApiService.get(`/api/v1/userProfile?loginId=${this.dataObj.loginId}`);
      if (response.status_code >= 200 && response.status_code < 300)
        return response.data
      else throw response;
    }
    catch (err) {
      console.error(`Failed to get user profile information.`);
      throw err;
    }
  }
}

export interface ProfilePictureApprovalSharedData {
  loginId: number,
  imageId: number,
  loginName: string,
  isApproved?: boolean
}
